module.exports = __webpack_public_path__ + "jo.svg?7e63436c0dd234d39c1eb0577457d0a0";